import React, { createContext, useContext, useMemo } from 'react';

import { PillexaRole } from '../utils/pillexa-roles';
import { useAuthContext } from './auth-context';

interface IRoleContext {
  pillexaRole?: PillexaRole;
  isLoadingRole: boolean;
}

const RoleContext = createContext<IRoleContext>({ isLoadingRole: true });

interface Props {
  children?: React.ReactNode;
}

export const RoleProvider = ({ children }: Props) => {
  const { user, isLoading } = useAuthContext();

  const pillexaRole = useMemo(() => user?.pillexa_role, [user]);

  return <RoleContext.Provider value={{ pillexaRole, isLoadingRole: isLoading }}>{children}</RoleContext.Provider>;
};

export const useRoleContext = () => useContext(RoleContext);
